var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#36A41D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.9375C20 14.6268 19.7482 14.375 19.4375 14.375C19.1268 14.375 18.875 14.6268 18.875 14.9375V21.125C18.875 21.3269 18.9832 21.5132 19.1584 21.6134L23.0959 23.8634C23.3657 24.0175 23.7093 23.9238 23.8634 23.6541C24.0175 23.3843 23.9238 23.0407 23.6541 22.8866L20 20.7986V14.9375Z",
    fill: "#36A41D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29C24.9706 29 29 24.9706 29 20C29 15.0294 24.9706 11 20 11C15.0294 11 11 15.0294 11 20C11 24.9706 15.0294 29 20 29ZM27.875 20C27.875 24.3492 24.3492 27.875 20 27.875C15.6508 27.875 12.125 24.3492 12.125 20C12.125 15.6508 15.6508 12.125 20 12.125C24.3492 12.125 27.875 15.6508 27.875 20Z",
    fill: "#36A41D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimings);
export default __webpack_public_path__ + "static/media/timings.c4efc783b3e68d732e3639f13fa29ab5.svg";
export { ForwardRef as ReactComponent };